const contentsExplorerUrl = '/contents-explorer';

export default contentsExplorerUrl;
